<!--
 * @Author: your name
 * @Date: 2020-10-23 09:30:49
 * @LastEditTime: 2021-05-17 11:19:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zhihui\roses-admin-vue\src\views\layout\AsideMenu.vue
-->
<template>
  <div>
    <el-menu
      :default-active="$route.path"
      background-color="#272B38"
      text-color="#C0C4CE"
      active-text-color="#fff"
      router
    >
      <!-- @open="handleOpen"
      @close="handleClose"-->
      <el-menu-item index="/home/system" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-1zixitongguanli"></i>
        <span slot="title">子系统管理</span>
      </el-menu-item>
      <el-menu-item index="/home/org" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan2-3qiyeguanli_1"></i>
        <span slot="title">机构管理</span>
      </el-menu-item>
      <el-menu-item index="/home/users" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-2yonghuguanli_1"></i>
        <span slot="title">用户管理</span>
      </el-menu-item>
      <el-submenu index="null" v-if="!isXiTongMana && !isAnQuanMana">
        <template slot="title">
          <i class="iconfont iconcaidan1-3rizhiguanli_1"></i>
          <span>日志管理</span>
        </template>
        <el-menu-item index="/home/access">访问日志</el-menu-item>
        <el-menu-item index="/home/action">操作日志</el-menu-item>
      </el-submenu>
      <el-menu-item index="/home/dictionary" v-if="!isXiTongMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-4zidianguanli_1"></i>
        <span slot="title">字典管理</span>
      </el-menu-item>
      <el-menu-item index="/home/onlineusers" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-5zaixianyonghu_1"></i>
        <span slot="title">在线用户</span>
      </el-menu-item>
      <el-menu-item index="/home/trialusers" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-6shiyongyonghuguanli"></i>
        <span slot="title">试用用户管理</span>
      </el-menu-item>
      <el-menu-item index="/home/dealmangement" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-6shiyongyonghuguanli"></i>
        <span slot="title">协议管理</span>
      </el-menu-item>
      <el-submenu index="devicemangement-null" v-if="!isAnQuanMana && !isShenJiMana">
        <template slot="title">
          <i class="iconfont iconcaidan1-7shebeiguanli"></i>
          <span>设备管理</span>
        </template>
        <el-menu-item index="/home/devicemangement"> 设备管理 </el-menu-item>
        <el-menu-item index="/home/devicetype"> 设备类型 </el-menu-item>
        <el-menu-item index="/home/deviceparameter"> 功能参数 </el-menu-item>
        <el-menu-item index="/home/devicebrand"> 设备品牌 </el-menu-item>
        <el-menu-item index="/home/deviceseries"> 设备系列 </el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="/home/device">
        <i class="iconfont iconcaidan1-7shebeiguanli"></i>
        <span slot="title">设备管理</span>
      </el-menu-item>
      <el-menu-item index="/home/devicetype">
        <i class="iconfont iconcaidan1-8shebeileixingguanli"></i>
        <span slot="title">设备类型管理</span>
      </el-menu-item> -->
      <el-menu-item index="/home/deviceauthorization" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-9shebeishouquanguanli"></i>
        <span slot="title">设备授权管理</span>
      </el-menu-item>
      <el-menu-item index="/home/appmangement" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-9shebeishouquanguanli"></i>
        <span slot="title">APP版本管理</span>
      </el-menu-item>
      <el-menu-item index="/home/flowmonitoring" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-6shiyongyonghuguanli"></i>
        <span slot="title">流量监控</span>
      </el-menu-item>
      <el-menu-item index="/home/srsmangement" v-if="!isAnQuanMana && !isShenJiMana">
        <i class="iconfont iconcaidan1-6shiyongyonghuguanli"></i>
        <span slot="title">SRS通道管理</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  computed: {
    isXiTongMana() {
      // 15200000000
      return this.$store.getters.userInfo.account == atob("MTUyMDAwMDAwMDA=");
    },
    isAnQuanMana() {
      // 15200000001
      return this.$store.getters.userInfo.account == atob('MTUyMDAwMDAwMDE=');
    },
    isShenJiMana() {
      // 15200000002
      return this.$store.getters.userInfo.account == atob('MTUyMDAwMDAwMDI=');
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-menu-item.is-active {
  background-color: #409eff !important;
}
.el-menu {
  border: none;
}

.iconfont {
  font-size: 24px;
  margin-right: 6px;
}
</style>
